import {useMutation} from '@tanstack/react-query';
import {OperationStateTypesEnum} from 'presentation/constants/operationStateEnum';
import {postConfirmPhone} from '../../services/postConfirmPhone';
import {useModalOtpConfirmationStateStore} from '../../store/modalOtpConfirmationStateStore';
import {AlertEnum} from '../../store/changeDataAlertStore/types';
import {ConfirmEmailMutationProps} from './types';

export function useConfirmPhoneMutation({setChangingCellphoneState}: ConfirmEmailMutationProps) {
	const setIsModalOtpConfirmationOpen = useModalOtpConfirmationStateStore(
		state => state.updateState,
	);

	return useMutation({
		mutationFn: postConfirmPhone,
		onMutate: async () => {
			setChangingCellphoneState(OperationStateTypesEnum.PENDING);
		},
		onSuccess: data => {
			setIsModalOtpConfirmationOpen({
				open: true,
				type: AlertEnum.CELLPHONE,
				data,
			});
			setChangingCellphoneState(OperationStateTypesEnum.DONE);
		},
		onError: () => {
			setChangingCellphoneState(OperationStateTypesEnum.ERROR);
		},
	});
}
